import React, { useState, useEffect, useContext } from "react";
import "./globalCss/Base.css";
import {
  fetchAffiliatons,
  fetchApps,
  fetchBanners,
  fetchIpsSettings,
} from "./requests";
import {
  Header,
  Footer,
  LoaderBars,
} from "@engelvoelkersamericas/common-story-ui";
import MainContentView from "./views/MainContentView";
import SearchOverlay from "./components/SearchOverlay";
import { hooks } from "@engelvoelkersamericas/common-story-ui";
import darkIcon from "./assets/darkWorld.svg";
import { observer } from "mobx-react-lite";
import { notificationsStore } from "./mobx/stores/notifications-store";
const { useProfileState } = hooks;
const GLOBAL_ASSET_BASE = window.__GLOBAL_ASSET_BASE__ || "/global";

const App = observer(function App() {
  // const [user, setUser] = useState(null);
  const [appGroups, setAppGroups] = useState(null);
  /**
   * undefined = fetching
   * null = no settings yet
   * object = settings
   */
  const [ipsSettings, setIpsSettings] = useState();
  const [isSearching, setIsSearching] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [banners, setBanners] = useState();
  const [affiliations, setAffiliations] = useState();

  function changeSearchValue(newValue) {
    if (typeof newValue === "string" && newValue.length) {
      window.scrollTo(0, 0);
    }
    setSearchValue(newValue);
  }
  const profile = useProfileState();

  //   createVideoView: async ƒ ()
  // fetchVideoViews: async ƒ ()
  // setPopupVideo: ƒ (isShow)
  // state:
  const staffId = profile?.staffId;
  useEffect(() => {
    if (staffId) {
      notificationsStore.fetchNotifications(staffId);
    }
  }, [staffId]);

  useEffect(() => {
    fetchApps()
      .then((appGroups) => setAppGroups(appGroups))
      .catch((error) => console.log(error));
    fetchBanners()
      .then((banners) => setBanners(banners))
      .catch((error) => console.log(error));
    fetchIpsSettings()
      .then((settings) => setIpsSettings(settings))
      .catch((error) => console.log(error));
    fetchAffiliatons(profile)
      .then((affiliations) => setAffiliations(affiliations))
      .catch((error) => console.log(error));
  }, [profile]);

  // reset search term on isSearch change

  useEffect(() => {
    setSearchValue("");
  }, [isSearching]);

  function reduceSortFilterIconGroup(appGroups, filterValue = "") {
    if (filterValue === "") return [];
    const r = appGroups
      .reduce((addedLinks, iconGroup) => {
        iconGroup.apps.forEach((link) => {
          // see if it is already in icons
          const foundLink = addedLinks.find(
            (addedLink) => addedLink.label === link.label,
          );
          if (
            !foundLink &&
            link.label.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1
          ) {
            // put in icons
            addedLinks.push(link);
          }
        });
        return addedLinks;
      }, [])
      .sort((linkA, linkB) => {
        const a = linkA.label.toUpperCase();
        const b = linkB.label.toUpperCase();
        return a < b ? -1 : a > b ? 1 : 0;
      });
    return r;
  }
  // /Applications/DynamodbLocal/DynamoDBLocal_lib

  if (appGroups === null || ipsSettings === undefined) {
    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          width: "100vw",
        }}
      >
        <LoaderBars />
      </div>
    );
  }

  const appGroupsWithOpenStatus = appGroups.map((group) => {
    if (group.id === -1) return group;

    const groupStatus = ipsSettings?.groupStatus?.find(
      (gs) => gs.id === group.id,
    );
    if (!groupStatus) return { ...group, opened: true };
    return { ...group, opened: groupStatus.opened };
  });

  return (
    <div className="App">
      {/* <VideoModal /> */}
      <Header
        cmsCourseId={4}
        productLogo={`${GLOBAL_ASSET_BASE}/static/logos/world.svg`}
        darkModeLogo={darkIcon}
        productName="World IPS"
        showAppMenu={false}
        showSupport
        showVideo
        isSearching={isSearching}
        setIsSearching={setIsSearching}
        searchValue={searchValue}
        setSearchValue={changeSearchValue}
        faqFolders={[{ label: "Popular", faqName: "worldPopular" }]}
      />
      {searchValue === "" ? (
        <MainContentView
          name={profile.firstName}
          appGroups={appGroupsWithOpenStatus}
          cmsBanners={banners}
          toggledValue={ipsSettings?.viewType}
          affiliations={affiliations}
        />
      ) : null}
      {isSearching ? (
        <SearchOverlay
          icons={reduceSortFilterIconGroup(appGroups, searchValue)}
          setIsSearching={setIsSearching}
          searchTerm={searchValue}
        />
      ) : null}
      <Footer />
    </div>
  );
});

export default App;
